import { render, staticRenderFns } from "./valoracion-individual.vue?vue&type=template&id=4e7c6ec1&"
import script from "./valoracion-individual.component.ts?vue&type=script&lang=ts&"
export * from "./valoracion-individual.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports